<script setup>

import {usePage} from "@inertiajs/vue3"
import CCartItemList from "@/Pages/Cart/Partials/CCartItemList.vue";
import CLink from "@/Components/CLink.vue";

const drawer = defineModel()
const page = usePage()

</script>

<template>
    <v-list lines="two" class="mx-6" :class="{ 'pt-10': $vuetify.display.mobile }" style="overflow-x: hidden">
        <v-list-item-title class="pa-5 font-weight-bold" inset>
            <v-row>
                <v-col cols="10" class="pt-5">
                    Lista de Orçamento
                </v-col>
                <v-col>
                    <v-btn icon="mdi-close" variant="flat" @click="drawer = false"/>
                </v-col>
            </v-row>
        </v-list-item-title>

        <CCartItemList v-model="drawer" :cart-items="page.props.cartItems" :compact="true" @close-drawer="drawer = false"/>

        <v-row class="pl-5 pt-5 pb-5" v-if="page.props.cartItems.length > 0">
            <v-col md="12" class="d-flex justify-end">
                <v-btn variant="flat" color="secondary" @click="drawer = false" class="font-weight-bold">
                    Continuar navegando
                </v-btn>
                <c-link :href="route('cart.checkout')" @click="drawer = false">
                    <v-btn variant="flat" color="primary" class="font-weight-bold ml-3">
                        Finalizar Orçamento
                    </v-btn>
                </c-link>
            </v-col>
        </v-row>
        <p v-if="page.props.cartItems.length === 0" class="pa-10">Você ainda não adicionou itens</p>
    </v-list>
</template>